import React from 'react';

import '../icon-component.scss';

const LoadingComponent = () => (
  <svg className="icon-component" viewBox="0 0 48 48">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
      <g transform="translate(-1559.000000, -2223.000000)" strokeWidth="1.5">
        <g transform="translate(1560.000000, 2223.000000)">
          <path
            d="M23,47 C10.298,47 0,36.702 0,24 C0,11.298 10.298,1 23,1 C35.702,1 46,11.298 46,24 C46,36.702 35.702,47 23,47 Z"
            className="loading--top"
          />
          <path
            d="M40.0956,8.6134 C43.7656,12.6894 45.9996,18.0834 45.9996,23.9994 C45.9996,36.7034 35.7016,46.9994 22.9996,46.9994 C10.2976,46.9994 -0.000399999999,36.7034 -0.000399999999,23.9994 C-0.000399999999,11.2974 10.2976,0.9994 22.9996,0.9994"
            className="loading--bottom"
          />
        </g>
      </g>
    </g>
  </svg>
);

LoadingComponent.displayName = 'LoadingIcon';

export default LoadingComponent;
